import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { CmsComponent, CmsService } from '@spartacus/core';
import { CmsComponentData, PageComponentModule } from '@spartacus/storefront';
import { combineLatest, Observable } from 'rxjs';
import { filter, switchMap } from 'rxjs/operators';

export interface GgGridComponent {
  uid: string;
  items: string;
  title: string;
}

@Component({
  selector: 'app-gg-grid-component',
  templateUrl: 'gg-grid.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [PageComponentModule, CommonModule],
})
export class GgGridComponent {
  // Services
  private componentData = inject(CmsComponentData<GgGridComponent>);
  private cmsService = inject(CmsService);

  // Signals
  data = toSignal(this.componentData.data$);

  gridItems = toSignal(
    this.componentData.data$.pipe(
      filter((data): data is GgGridComponent => !!data?.items),
      switchMap(
        (data) =>
          combineLatest(
            data.items.split(' ').map((uid: string) => this.cmsService.getComponentData<CmsComponent>(uid))
          ) as Observable<CmsComponent[]>
      )
    )
  );
}
